import { includes } from 'ramda';
import { isNilOrEmptyString } from 'ramda-extension';
import { useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { USER_ROLES } from 'constants/general';
import { DISPLAY_SUMMARY_OVERVIEW, DISPLAY_SUMMARY_OVERVIEW_MANAGER } from 'features/common/acl/constants';
import { getCurrentRole } from 'features/views/user/selectors';

import DashboardManager from './DashboardManager';
import DashboardSellerPpz from './DashboardSellerPpz';

export const DashboardMain = () => {
	const currentRole = useSelector(getCurrentRole);

	if (includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]) || isNilOrEmptyString(currentRole)) {
		return (
			<AccessControl accessLevel={DISPLAY_SUMMARY_OVERVIEW} showAccessDenied>
				<DashboardSellerPpz />
			</AccessControl>
		);
	}

	if (currentRole === USER_ROLES.GROUP_MANAGER) {
		return (
			<AccessControl accessLevel={DISPLAY_SUMMARY_OVERVIEW_MANAGER} showAccessDenied>
				<DashboardManager />
			</AccessControl>
		);
	}
};

export default DashboardMain;
